import { useWindowSize } from 'react-use';

type Viewport = {
  width: number;
  height: number;
};

function useViewport(): Viewport {
  const { width, height } = useWindowSize();

  return { width, height };
}

export default useViewport;
